import React, { useEffect, useRef, useState } from "react";
import {
	RATES,
	readRate,
	setRate,
	subscribe,
	nextRate,
	registerAudio,
	pauseOthers,
} from "./store";

const labelOf = (rate) => (rate === 1 ? "1x" : rate === 1.5 ? "1.5x" : "2x");

const AudioMessage = ({ src, type = "audio/ogg" }) => {
	const audioRef = useRef(null);
	const [rate, setLocalRate] = useState(readRate());

	// Sincroniza este player com mudanças globais (clique em outro player ou outra aba).
	useEffect(() => {
		return subscribe((r) => {
			setLocalRate(r);
			const el = audioRef.current;
			if (el) {
				try { el.playbackRate = r; } catch (_) { /* ignore */ }
			}
		});
	}, []);

	// Aplica a velocidade no elemento sempre que o estado local mudar (inclusive no mount).
	useEffect(() => {
		const el = audioRef.current;
		if (!el) return;
		try { el.playbackRate = rate; } catch (_) { /* ignore */ }
	}, [rate]);

	// Listeners do elemento: registro singleton, "só 1 tocando", reforço de rate.
	useEffect(() => {
		const el = audioRef.current;
		if (!el) return undefined;

		const unregister = registerAudio(el);

		const onPlay = () => pauseOthers(el);

		const onLoaded = () => {
			try { el.playbackRate = readRate(); } catch (_) { /* ignore */ }
		};

		// Detecta mudança via menu nativo do navegador (botão direito > "Velocidade de reprodução")
		// e promove para padrão global se for uma das taxas suportadas.
		const onRateChange = () => {
			const v = el.playbackRate;
			if (RATES.includes(v) && v !== readRate()) {
				setRate(v);
			}
		};

		el.addEventListener("play", onPlay);
		el.addEventListener("loadedmetadata", onLoaded);
		el.addEventListener("ratechange", onRateChange);

		return () => {
			el.removeEventListener("play", onPlay);
			el.removeEventListener("loadedmetadata", onLoaded);
			el.removeEventListener("ratechange", onRateChange);
			unregister();
		};
	}, []);

	const cycleRate = () => {
		setRate(nextRate(rate));
	};

	return (
		<span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
			<audio ref={audioRef} controls>
				<source src={src} type={type} />
			</audio>
			<button
				type="button"
				onClick={cycleRate}
				title="Velocidade de reprodução"
				style={{
					cursor: "pointer",
					fontSize: 11,
					padding: "2px 6px",
					border: "1px solid #ccc",
					borderRadius: 12,
					background: "#f5f5f5",
					minWidth: 36,
					lineHeight: 1,
				}}
			>
				{labelOf(rate)}
			</button>
		</span>
	);
};

export default AudioMessage;
